(() => {
  const SELECTOR = '[data-inopro-formula-comparison]';

  const moneylessError = 'We could not add both formulas. Please try again.';

  function setMessage(root, message) {
    root.querySelectorAll('[data-inopro-duo-error]').forEach((element) => {
      element.textContent = message;
    });
  }

  function setLoading(root, isLoading) {
    root.querySelectorAll('[data-inopro-duo-add]').forEach((button) => {
      button.disabled = isLoading;
      button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    });
  }

  async function addDuo(root, trigger) {
    const innovativeVariantId = Number(root.dataset.innovativeVariantId);
    const advancedVariantId = Number(root.dataset.advancedVariantId);

    if (!innovativeVariantId || !advancedVariantId) {
      setMessage(root, 'Both products must be selected in the theme editor.');
      return;
    }

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const payload = {
      items: [
        { id: innovativeVariantId, quantity: 1 },
        { id: advancedVariantId, quantity: 1 },
      ],
    };

    if (cart && typeof cart.getSectionsToRender === 'function') {
      payload.sections = cart.getSectionsToRender().map((section) => section.id);
      payload.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(trigger);
    }

    setMessage(root, '');
    setLoading(root, true);

    try {
      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(payload),
      });
      const cartData = await response.json();

      if (!response.ok || cartData.status) {
        throw new Error(cartData.description || cartData.message || moneylessError);
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'inopro-formula-comparison',
          productVariantId: `${innovativeVariantId},${advancedVariantId}`,
          cartData,
        });
      }

      if (cart && typeof cart.renderContents === 'function' && cartData.sections) {
        cart.renderContents(cartData);
        setLoading(root, false);
      } else {
        window.location.assign(window.routes?.cart_url || '/cart');
      }
    } catch (error) {
      setMessage(root, error instanceof Error ? error.message : moneylessError);
      setLoading(root, false);
    }
  }

  function init(root) {
    if (root.dataset.inoproDuoReady === 'true') return;
    root.dataset.inoproDuoReady = 'true';

    root.querySelectorAll('[data-inopro-duo-add]').forEach((button) => {
      button.addEventListener('click', () => addDuo(root, button));
    });
  }

  function initAll(scope = document) {
    scope.querySelectorAll(SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
